var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState, } from 'react';
import { useFetch } from '../hooks/useFetch';
import { useConfig } from './ConfigContext';
// These correspond to enums in
// https://github.com/robinpowered/robin-api/blob/800aad/src/Robin/Api/Integration/Entity/IntegrationType.php#L18
export var VideoConferencingLinkEnums = {
    zoom: 1 << 1, // 2
    bluejeans: 1 << 2, // 4
    slack: 1 << 3, // 8
    bluejeans_relay: 1 << 4, // 16
    teams: 1 << 5, // 32
};
var IntegrationsContext = createContext({
    automaticIntegrations: [],
    loading: false,
    error: undefined,
});
function parseEnumValue(settingValue, settingEnums) {
    var value = parseInt(settingValue);
    return Object.keys(settingEnums).filter(function (key) {
        var flag = settingEnums[key];
        return (value & flag) === flag;
    });
}
export var IntegrationsProvider = function (_a) {
    var children = _a.children;
    var _b = useConfig(), userContext = _b.userContext, environmentUrls = _b.environmentUrls, accessToken = _b.accessToken;
    var currentOrg = userContext.currentOrg;
    var apiUrl = environmentUrls.apiUrl;
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(undefined), 2), error = _d[0], setError = _d[1];
    var _e = __read(useState([]), 2), automaticIntegrations = _e[0], setAutomaticIntegrations = _e[1];
    var get = useFetch(accessToken).get;
    var getVideoConferencingSetting = useCallback(function (orgId) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            setLoading(true);
            setError(undefined);
            url = "".concat(apiUrl, "/organizations/").concat(orgId, "/settings/automatic-video-conferencing-link-creation");
            return [2 /*return*/, get(url)
                    .then(function (response) {
                    setAutomaticIntegrations(parseEnumValue(response.data.value, VideoConferencingLinkEnums));
                })
                    .catch(function (err) {
                    setError(err);
                })
                    .finally(function () {
                    setLoading(false);
                })];
        });
    }); }, [get, apiUrl]);
    useEffect(function () {
        if (!currentOrg) {
            return;
        }
        getVideoConferencingSetting(currentOrg.id);
    }, [currentOrg, getVideoConferencingSetting]);
    return (_jsx(IntegrationsContext.Provider, { value: {
            automaticIntegrations: automaticIntegrations,
            loading: loading,
            error: error,
        }, children: children }));
};
export var useIntegrationsContext = function () {
    return useContext(IntegrationsContext);
};
